<template>
  <div class="detail-item">
    <span class="label">{{ label }}</span>
    <slot name="value">
      <span class="value">{{ value || '—' }}</span>
    </slot>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true
  },
  value: {
    type: String,
    default: ''
  }
})
</script>

<style scoped>
.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #409eff;
}

.label {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
}

.value {
  font-size: 14px;
  color: #303133;
  line-height: 1.6;
  word-break: break-word;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .detail-item {
    padding: 10px;
  }

  .label {
    font-size: 12px;
  }

  .value {
    font-size: 13px;
  }
}
</style>
